import { useEffect, useRef } from 'react';

export const mountScript = (url: string, integrity?: string) =>
  new Promise<void>(resolve => {
    const isScriptMounted = !!document.querySelector(`script[src="${url}"]`);
    if (isScriptMounted) {
      resolve();
    } else {
      const script = document.createElement('script');
      script.src = url;
      if (integrity) {
        script.integrity = integrity;
        script.crossOrigin = 'anonymous';
      }
      script.addEventListener('load', () => resolve());
      document.head.appendChild(script);
    }
  });

const useScript = (url: string, integrity?: string) => {
  const promiseRef = useRef<Promise<void>>();
  useEffect(() => {
    promiseRef.current = mountScript(url, integrity);
  }, []);
  return promiseRef;
};

export default useScript;
